import React, { useContext, useState } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { MessageBar, MessageBarButton, MessageBarType } from '@bingads-webui-react/fabric-control';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';

import { useStyles } from './styles';
import { AccountPausedWarningType, IOExpiringWarningType, IOExhaustingWarningType } from './constants';

const { IOFilter } = Constants;

export function IOWarningCustomerMessageBar({
  numOfAccountPaused, numOfIOExpiring, numOfIOExhausting, buttonOnClick, dismissOnClick,
}) {
  const styles = useStyles();
  const i18n = useContext(I18nContext);
  const [showAccountPaused, setShowAccountPaused] = useState(numOfAccountPaused > 0);
  const [showIOExpiring, setShowIOExpiring] = useState(numOfIOExpiring > 0);
  const [showIOExhausting, setShowIOExhausting] = useState(numOfIOExhausting > 0);
  const accountPausedText = numOfAccountPaused === 1 ?
    i18n.getString(
      _TL_('Your ads are not displaying because {{numOfAccountPaused}} of your accounts is paused due to their insertion orders have expired or exhausted.'),
      { numOfAccountPaused }
    ) :
    i18n.getString(
      _TL_('Your ads are not displaying because {{numOfAccountPaused}} of your accounts are paused due to their insertion orders have expired or exhausted.'),
      { numOfAccountPaused }
    );
  const IOExpiringText = numOfIOExpiring === 1 ?
    i18n.getString(
      _TL_('{{numOfIOExpiring}} of your account\'s insertion orders is expiring soon. To make sure your ads can display, please extend the end date or add new orders.'),
      { numOfIOExpiring }
    ) :
    i18n.getString(
      _TL_('{{numOfIOExpiring}} of your accounts\' insertion orders are expiring soon. To make sure your ads can display, please extend the end date or add new orders.'),
      { numOfIOExpiring }
    );
  const IOExhaustingText = numOfIOExhausting === 1 ?
    i18n.getString(
      _TL_('The budget for {{numOfIOExhausting}} of your account\'s insertion orders will exhaust soon. To make sure your ads can display, please increase the budget or create new orders.'),
      { numOfIOExhausting }
    ) :
    i18n.getString(
      _TL_('The budget for {{numOfIOExhausting}} of your accounts\' insertion orders will exhaust soon. To make sure your ads can display, please increase the budget or create new orders.'),
      { numOfIOExhausting }
    );

  return (
    <>
      {showAccountPaused &&
      <MessageBar
        className={classnames('io-warning', 'io-warning-paused', 'io-warning-customer-level', styles.WarningMessageBar)}
        messageBarType={MessageBarType.severeWarning}
        actions={
          <MessageBarButton
            onClick={() => {
              buttonOnClick({ iofilter: IOFilter.AccountPaused, warningsTypeIds: AccountPausedWarningType });
            }}
          >
            {i18n.getString(_TL_('Fix it'))}
          </MessageBarButton>
        }
        isMultiline={false}
        onDismiss={() => {
          setShowAccountPaused(false);
          dismissOnClick(AccountPausedWarningType);
        }}
      >
        <span className={styles.WarningMessageText} title={accountPausedText}>
          <b>{i18n.getString(_TL_('Account Paused: '))}</b>
          {accountPausedText}
        </span>
      </MessageBar>}
      {showIOExpiring &&
      <MessageBar
        className={classnames('io-warning', 'io-warning-expiring', 'io-warning-customer-level', styles.WarningMessageBar)}
        messageBarType={MessageBarType.severeWarning}
        actions={
          <MessageBarButton
            onClick={() => {
              buttonOnClick({ iofilter: IOFilter.Expiring, warningsTypeIds: IOExpiringWarningType });
            }}
          >
            {i18n.getString(_TL_('Fix it'))}
          </MessageBarButton>
        }
        isMultiline={false}
        onDismiss={() => {
          setShowIOExpiring(false);
          dismissOnClick(IOExpiringWarningType);
        }}
      >
        <span className={styles.WarningMessageText} title={IOExpiringText}>
          <b>{i18n.getString(_TL_('Insertion Order Expiring: '))}</b>
          {IOExpiringText }
        </span>
      </MessageBar>}
      {showIOExhausting &&
      <MessageBar
        className={classnames('io-warning', 'io-warning-exhausting', 'io-warning-customer-level', styles.WarningMessageBar)}
        messageBarType={MessageBarType.severeWarning}
        actions={
        <MessageBarButton
          onClick={() => {
            buttonOnClick({ iofilter: IOFilter.Exhausting, warningsTypeIds: IOExhaustingWarningType });
          }}
        >
          {i18n.getString(_TL_('Fix it'))}
        </MessageBarButton>
        }
        isMultiline={false}
        onDismiss={() => {
          setShowIOExhausting(false);
          dismissOnClick(IOExhaustingWarningType);
        }}
      >
        <span className={styles.WarningMessageText} title={IOExhaustingText}>
          <b>{i18n.getString(_TL_('Insertion Order Exhausting: '))}</b>
          {IOExhaustingText}
        </span>
      </MessageBar>}
    </>
  );
}

IOWarningCustomerMessageBar.defaultProps = {
  numOfAccountPaused: 0,
  numOfIOExpiring: 0,
  numOfIOExhausting: 0,
  buttonOnClick: _.noop,
};

IOWarningCustomerMessageBar.propTypes = {
  numOfAccountPaused: PropTypes.number,
  numOfIOExpiring: PropTypes.number,
  numOfIOExhausting: PropTypes.number,
  buttonOnClick: PropTypes.func,
};
